import React, { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';

const CarBuyerForm = ({ onBuyerCreated, carData, currentData }) => {
  const [buyerForm, setBuyerForm] = useState([
    {
      name: 'JuridicalName',
      label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ ÑÑ. Ð»Ð¸ÑÐ°',
      placeholder: 'Ð¢ÐÐ',
      rules: { required: true },
      defaultValue: currentData?.JuridicalName,
      capitalize: true,
    },
    {
      name: 'JuridicalDirectorName',
      label: 'Ð¤ÐÐ Ð´Ð¸ÑÐµÐºÑÐ¾ÑÐ°',
      placeholder: '',
      rules: { required: true },
      defaultValue: currentData?.JuridicalDirectorName,
      capitalize: true,
    },
    {
      name: 'CompanyDetails',
      label: 'Ð ÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸',
      placeholder: 'ÐÐÐ 123456789, Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ÐÑÐ¸Ð¼ÐµÑÐ½Ð°Ñ, 1',
      rules: { required: true },
      defaultValue: currentData?.CompanyDetails,
    },
    {
      name: 'ContractNumber',
      label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°',
      placeholder: '123/2024',
      rules: { required: true },
      defaultValue: currentData?.ContractNumber,
    },
    {
      name: 'RepairWorkList',
      label: 'Ð¡Ð¿Ð¸ÑÐ¾Ðº ÑÐ°Ð±Ð¾Ñ',
      placeholder: 'ÐÐ°Ð¼ÐµÐ½Ð° Ð¼Ð°ÑÐ»Ð°, ÑÐ¸Ð½Ð¾Ð¼Ð¾Ð½ÑÐ°Ð¶',
      rules: { required: true },
      defaultValue: currentData?.RepairWorkList,
    },
  ]);

  const handleBuyerSubmit = (values) => {
    if (onBuyerCreated) {
      onBuyerCreated(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={buyerForm}
        title={'ÐÐ°Ð½Ð½ÑÐµ Ð¿Ð¾ÐºÑÐ¿Ð°ÑÐµÐ»Ñ (ÑÑ. Ð»Ð¸ÑÐ¾)'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}
        handlerSetState={setBuyerForm}
        onSubmit={handleBuyerSubmit}
        action={'ÐÐ°Ð»ÐµÐµ'}
        border
      />
    </div>
  );
};

export default CarBuyerForm; 